<template>
    <d-row>
        <d-col lg="12" class="mb-4">
            <d-card class="card-small">

                <d-card-header class="border-bottom">
                    <d-row>
                        <d-col sm="3" xs="12" class="mb-2">
                            <h6 class="m-0">Filters</h6>
                        </d-col>
                        <d-col sm="9" xs="12" class="d-flex justify-content-center justify-content-md-end">
                            <export-funnel-report
                                :start-date="dateRange.from"
                                :end-date="dateRange.to"
                                :website-id="website"
                            />
                        </d-col>
                    </d-row>
                </d-card-header>

                <d-list-group flush>
                    <d-list-group-item class="pl-3 pr-3 pt-4 pt-0">
                        <d-row>
                            <d-col>
                                <d-form id="performanceForm" @submit.prevent="applyFilters">
                                    <d-form-row>
                                        <d-col lg="4" class="form-group performance-form">
                                            <d-input-group class="date-range">
                                                <calendar-picker :date-range="dateRange"/>
                                            </d-input-group>
                                        </d-col>
                                        <d-col lg="4" class="form-group performance-form">
                                            <b-form-select
                                                @change="setWebsite"
                                            >
                                                <option value="" >All domains</option>
                                                <option
                                                    v-for="item in websites"
                                                    :key="item.id"
                                                    :value="item.id"
                                                >
                                                    {{ item.domain }}
                                                </option>
                                            </b-form-select>
                                        </d-col>
                                        <d-col lg="4" class="form-group performance-form">
                                            <d-input-group>
                                                <input value="Apply filter" type="submit" class="btn mr-1 btn-primary">
                                                <input type="button" value="Reset filter" @click="resetFilters"
                                                       class="btn mr-1 btn-secondary">
                                            </d-input-group>
                                        </d-col>
                                    </d-form-row>
                                </d-form>
                            </d-col>
                        </d-row>
                    </d-list-group-item>
                </d-list-group>
            </d-card>
        </d-col>
    </d-row>
</template>
<script>
    import {WebsiteService} from '@/main'
    import ExportFunnelReport from '@/components/common/ExportFunnelReport.vue';
    import CalendarPicker from '@/components/form/calendarPicker.vue';
    import CurrentDate from '@/helpers/date';
    import moment from 'moment'

    export default {
        components: {
            CalendarPicker,
            ExportFunnelReport
        },

        data() {
            return {
                page: 1,
                type: 'test',
                websites: [],
                website: '',
                dateRange: { from: '', to: '' },
                reportRange: 31,
            };
        },

        methods: {
            applyFilters() {
                this.$store.commit('analysisStore/setWebsiteId', this.website)
                this.$store.commit('analysisStore/setDates', {
                        "from": moment(this.dateRange.from).format('YYYY-MM-DD'),
                        "to": moment(this.dateRange.to).format('YYYY-MM-DD')
                    })

                this.$eventHub.$emit('apply-analysis-filters')
            },
            resetFilters() {
                this.setDateRange()
                this.website = ''

                this.$store.commit('analysisStore/setWebsiteId', this.website)
                this.$store.commit('analysisStore/setDates', {"from": this.dateRange.from, "to": this.dateRange.to})
                this.$eventHub.$emit('apply-analysis-filters')
            },
            setWebsite(website) {
                this.website = website
            },
            async getWebsites() {
                try {
                    this.websites = await WebsiteService.get()
                } catch (e) {
                    this.showNotification('warn', 'Oops! we have a problem', 'Oops! cant get domains')
                    console.error(e)
                }
            },
            setDateRange() {
                this.dateRange.from = CurrentDate.getCurrentMonthStart()
                this.dateRange.to = CurrentDate.getDateToday()
            }
        },
        watch: {
            'dateRange.from' (val) {
                let from = moment(val);
                let to = moment(this.dateRange.to);
                if (to.diff(from, 'days') > this.reportRange) {
                    this.dateRange.to = moment(from).add(31, 'days').format('YYYY-MM-DD');
                }
            },
            'dateRange.to' (val) {
                let to = moment(val);
                let from = moment(this.dateRange.from);
                if (to.diff(from, 'days') > this.reportRange) {
                    this.dateRange.from = moment(to).subtract(31, 'days').format('YYYY-MM-DD');
                }
            }
        },
        mounted() {
            this.getWebsites()
            this.setDateRange()
        }
    };
</script>
